<template>
  <div class="flight-summary">
    <content-section title="Qui trovi il riepilogo del tuo volo">
      <template>
        <div class="flight-summary__wrapper">
          <flight-pad-detail-title
            v-for="(itinerary, index) in flight_offer.itineraries"
            :key="_uid + index"
            :itinerary="itinerary"
          />
          <div class="flight-summary__link" @click="show_details">
            <span>vedi dettagli</span>
            <vb-icon :name="'angle_small_right'" :color="sass('info')" :size="16" />
          </div>
        </div>
      </template>
    </content-section>

    <flight-pad-details-modal
      ref="details_modal"
      :wrapper_id="details_ref_id"
      :flight_offer="flight_offer"
    />
  </div>
</template>

<script>
import ContentSection from "@liveflight/components/blocks/wrappers/content-section.vue";
import FlightPadDetailTitle from "@liveflight/components/blocks/flight-pad/flight-pad-details/flight-pad-detail-title.vue";
import FlightPadDetailsModal from "@liveflight/components/blocks/flight-pad/flight-pad-details/flight-pad-details-modal.vue";

export default {
  name: "flight-summary",

  components: {
    "flight-pad-detail-title": FlightPadDetailTitle,
    "flight-pad-details-modal": FlightPadDetailsModal,
    "content-section": ContentSection,
  },

  props: {
    flight_offer: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    // id univoco per la modale di dettaglio (include _uid per evitare collisioni tra istanze)
    details_ref_id() {
      return `checkout:flight-summary:${this.flight_offer.id}:${this._uid}`;
    },
  },

  methods: {
    show_details() {
      if (this.$refs.details_modal) {
        this.$refs.details_modal.show_modal();
      }
    },
  },
};
</script>

<style lang="scss" scoped>

  .flight-summary {

    &__wrapper {
      margin-top: $grid-gutter-20;
    }

    &__link {
      display: flex;
      align-items: center;
      margin-top: $grid-gutter-width;
      cursor: pointer;

      span {
        color: $info;
        text-decoration: underline;
        margin-right: 0 !important;
        line-height: normal;
        font-size: $font-size-md;
        margin-top: -($grid-gutter-width / 9);
      }
    }

    ::v-deep {
      .flight-pad-detail-title {
        margin-bottom: $grid-gutter-width / 10;

        &__iata {
          font-size: $font-size-lg;
          color: $text;
          font-weight: normal;
        }
      }
    }
  }

</style>